/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meal_DinnerInputs */

const en_meal_dinner = /** @type {(inputs: Meal_DinnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dinner`)
};

const de_meal_dinner = /** @type {(inputs: Meal_DinnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abendessen`)
};

/**
* | output |
* | --- |
* | "Dinner" |
*
* @param {Meal_DinnerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const meal_dinner = /** @type {((inputs?: Meal_DinnerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meal_DinnerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_meal_dinner(inputs)
	return en_meal_dinner(inputs)
});